import React from "react";
import { Map, Sprout, Brain, House, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Externe Beoordeling",
  description: "Inzet van BKE-gecertificeerde assessoren voor betrouwbare examinering en kwaliteitsborging binnen uw hbo-opleidingen.",
  icon: Brain,
  href: "#"
}, {
  title: "Langstudeerbegeleiding",
  description: "Intensieve begeleiding gericht op het succesvol afronden van de studie en het verhogen van het rendement voor uw instelling.",
  icon: Sprout,
  href: "#"
}, {
  title: "Onderwijsbeleid & Advies",
  description: "Strategische ondersteuning bij curriculumontwikkeling, accreditaties en het versterken van de algehele onderwijskwaliteit.",
  icon: Map,
  href: "#"
}, {
  title: "Onderwijsprofessionals",
  description: "Toegang tot een breed netwerk van docenten en onderzoekers voor flexibele capaciteitsvraagstukken en tijdelijke opdrachten.",
  icon: House,
  href: "#"
}];
export default function OnzeWegwijzers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="62362" id="de-mogelijkheden-met-edumedius" className="bg-background text-foreground py-20 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-chart-2/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={cn("transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <div className="text-center mb-16 max-w-2xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-default font-bold mb-4 tracking-tight text-primary">De mogelijkheden met EduMedius</h2>
            <p className="text-muted-foreground text-lg">
              Hoogwaardige ondersteuning voor onderwijsinstellingen door inzet van BKE-gecertificeerde professionals en strategisch advies.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
            {services.map((service, i) => <div key={i} data-index={i} className="group h-full">
                <Card className="h-full border-border/50 border-t-2 border-t-chart-2 bg-card backdrop-blur-sm transition-all duration-300 hover:bg-accent/5 hover:border-chart-2/30 hover:shadow-xl hover:shadow-chart-2/10 group-hover:-translate-y-2">
                  <CardHeader className="items-center text-center pb-2">
                    <div className="mb-4 p-4 rounded-full bg-primary/10 text-chart-2 ring-1 ring-chart-2/20 group-hover:bg-primary/20 group-hover:scale-110 transition-all duration-300">
                      <service.icon className="w-8 h-8" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-default font-semibold text-primary group-hover:text-chart-2 transition-colors">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center px-6">
                    <CardDescription className="text-muted-foreground/80 text-base leading-relaxed line-clamp-3">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="justify-center pb-8 pt-2">
                    <Link to={service.href} className="inline-flex items-center text-sm font-medium text-chart-2 hover:text-primary transition-colors group/link">
                      Lees meer
                      <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}